import Vue from 'vue';
import Vuex from 'vuex';

import { RootState } from '@/interfaces/root-state';
import { UserInfo } from '@/interfaces/user-info';
import API from '@/services/rest-api';

import { repo } from './modules/repo';

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  state: {
    showGlobalLoader: false,
    userInfo: null
  },
  mutations: {
    showGlobalLoader(state, payload) {
      state.showGlobalLoader = payload;
    },
    setUserInfo: (state, userInfo: UserInfo) => {
      state.userInfo = userInfo;
    },
    setUserOrgs: (state, orgs: string[]) => {
      state.orgs = orgs;
    }
  },
  actions: {
    showGlobalLoader({ commit }, isShow) {
      commit('showGlobalLoader', isShow);
    },
    async authorize({ commit, dispatch }) {
      dispatch('showGlobalLoader', true);
      const res = await API.authorize();
      if (!res.success) {
        window.location.href = `${process.env.VUE_APP_AUTH_SERVER}?redir=${encodeURIComponent(window.location.href)}`;
      }
      commit('setUserInfo', res.UserInfo);
      dispatch('showGlobalLoader', false);
    }
  },
  modules: {
    repo,
  }
});
